import React, { useState } from 'react';
const UserDataModal = ({ missingFields, onClose, onSubmit }) => {
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await onSubmit(formData);
            onClose();
        }
        catch (error) {
            console.error('Error submitting form:', error);
        }
        finally {
            setIsSubmitting(false);
        }
    };
    const handleInputChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };
    return (<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md max-h-[90vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4">Update User Information</h2>
                <form onSubmit={handleSubmit}>
                    {missingFields.includes('firstname') && (<div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Vorname</label>
                            <input type="text" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" value={formData.firstname || ''} onChange={(e) => handleInputChange('firstname', e.target.value)} required/>
                        </div>)}

                    {missingFields.includes('lastname') && (<div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Nachname</label>
                            <input type="text" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" value={formData.lastname || ''} onChange={(e) => handleInputChange('lastname', e.target.value)} required/>
                        </div>)}

                    {missingFields.includes('insurance') && (<div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Versicherungsnummer</label>
                            <input type="text" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" value={formData.insurance || ''} onChange={(e) => handleInputChange('insurance', e.target.value)} required/>
                        </div>)}

                    {missingFields.includes('birthday') && (<div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700">Geburtstag</label>
                            <input type="text" placeholder={'DD.MM.YYYY'} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500" value={formData.birthday || ''} onChange={(e) => handleInputChange('birthday', e.target.value)} required/>
                        </div>)}

                    <div className="mt-6 flex justify-end gap-3">
                        <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200" disabled={isSubmitting}>
                            Abbrechen
                        </button>
                        <button type="submit" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:bg-blue-400" disabled={isSubmitting}>
                            {isSubmitting ? 'Speichern...' : 'Speichern'}
                        </button>
                    </div>
                </form>
            </div>
        </div>);
};
export default UserDataModal;
